export const MOBILE_USER_AGENT_REGEX = /mobi/i;

/**
 * Detects if the current device is mobile based on user agent string.
 *
 * @returns true if the device is detected as mobile, false otherwise
 */
export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined' || navigator.userAgent == null) {
    return false;
  }

  return MOBILE_USER_AGENT_REGEX.test(navigator.userAgent.toLowerCase());
};
